import { api } from '../../../lib/api'

export const DELETE_MY_PROFILE_REQUEST = 'DELETE_MY_PROFILE_REQUEST'
export const DELETE_MY_PROFILE_SUCCESS = 'DELETE_MY_PROFILE_SUCCESS'
export const DELETE_MY_PROFILE_FAILED = 'DELETE_MY_PROFILE_FAILED'

export const deleteMyProfile = function (onComplete) {
    return function (dispatch) {
        dispatch({
            type: DELETE_MY_PROFILE_REQUEST
        })
        api.deleteMyProfile().then(deleteProfileResponse => {
            dispatch({
                type: DELETE_MY_PROFILE_SUCCESS,
                payload: deleteProfileResponse
            })
            dispatch({
                type: 'RESET'
            })
            onComplete()
        }).catch(error => {
            dispatch({
                type: DELETE_MY_PROFILE_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile/delete-profile.js